export enum EnergySystemStatus {
  Idle = 'idle',
  Charging = 'charging',
  Discharging = 'discharging',
}

export type EnergySystem = {
  /**
   * The id is a uuid string for the energy system, however the creation
   * request takes an authentication id, which is a number
   */
  id: string | number
  status: EnergySystemStatus | null
  state_of_charge_percentage: number | null
  operating_mode_setting: string // example: 'Autonomous'
  grid_charging_allowed: boolean
  has_multiple_batteries: boolean
  name: string | null
}
